import React, { useState } from "react";
import { Box, Grid, Text, Flex, GridItem, Skeleton } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import CustomButton from "../custom/Button";

export function OrderTitle () {
  return (
    <Box w='100%' pb='3' borderBottom='1px' borderColor='#286090' display = { ['none', 'none', 'block']}>
      <Grid templateColumns='repeat(5, 1fr)' gap={6}>
        <GridItem>
          <Text
            fontWeight='bold' mt='10'
            fontSize={['xs', 'xs', 'xs', 'md']}
            color='gray.500'
          >
            ID
          </Text>
        </GridItem>

        <GridItem>
          <Text
            fontWeight='bold' fontSize={['xs', 'xs', 'xs', 'md']}
            mt='10' color='gray.500'>
            Payment Method
          </Text>
        </GridItem>

        <GridItem>
          <Text
            fontWeight='bold' fontSize={['xs', 'xs', 'xs', 'md']}
            mt='10' color='gray.500'>
            Payment Provider
          </Text>
        </GridItem>

        <GridItem>
          <Text
            fontWeight='bold' fontSize={['xs', 'xs', 'xs', 'md']}
            mt='10' color='gray.500'>
            Amount
          </Text>
        </GridItem>

        <GridItem>
          <Text
            fontWeight='bold' fontSize={['xs', 'xs', 'xs', 'md']}
            mt='10' color='gray.500'>
            Date Placed
          </Text>
        </GridItem>
      </Grid>
    </Box>
  )
}

export function OrderSkeleton () {
  return (
    <Box>
      <Grid
        style={{
          borderBottom: '1px solid #286090',
        }}
        templateColumns={[
          'repeat(1, 1fr)',
          'repeat(1, 1fr)',
          'repeat(5, 1fr)'
        ]} gap={[2, 6]} py={5}
      >
        <GridItem overflow='hidden'>
          <Skeleton h={5} w='100%' />
        </GridItem>

        <GridItem overflow='hidden'>
          <Skeleton h={5} w='30%' />
        </GridItem>

        <GridItem overflow='hidden'>
          <Skeleton h={5} w='40%' />
        </GridItem>

        <GridItem overflow='hidden'>
          <Skeleton h={5} w='40%' />
        </GridItem>

        <GridItem overflow='hidden'>
          <Skeleton h={5} w='60%' />
        </GridItem>
      </Grid>
    </Box>
  )
}

const Order = ({ order }: any) => {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => setIsHovering(true)
  const handleMouseLeave = () => setIsHovering(false)

  const buttonStyles = {
    width: '100%',
    textAlign: 'left',
    backgroundColor: isHovering ? '#f2f2f2' : 'white',
    borderRadius: '10px',
    paddingLeft: '5px',
    paddingRight: '5px',
    paddingTop: '25px',
    paddingBottom: '25px',
    transition: 'background-color 100ms ease-in',
    borderBottom: '1px solid #286090'
  }

  const linkStyles = { width: '100%' }

  return (
    <Link 
      style={linkStyles} 
      to={`/orders/${order._id}`}
    >
      <CustomButton 
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={buttonStyles}
      >
        <Box display={['block', 'block', 'none']}>
          <Flex
            w='100%'
            justifyContent='space-between'
          >
            <Box>
              <Text
                w='fit-content'
                fontSize={['xs', 'xs', 'xs', 'md']} color='gray.500'>
                #{order._id}
              </Text>

              <Text
                mt='2'
                fontSize={['xs', 'xs', 'xs', 'md']} color={order.payment_method === 'cod' ? 'blue.500' : 'green.500'}>
                {order.payment_method === 'cod' ? 'C.O.D' : 'Card'}
              </Text>
            </Box>

            <Box textAlign='right'>
              <Text
                fontSize={['xs', 'xs', 'xs', 'md']} color='gray.500'>
                #{order.amount}
              </Text>

              <Text
                mt='2'
                fontSize={['xs', 'xs', 'xs', 'md']} color='pink.500'>
                {order.date_placed}
              </Text>
            </Box>
          </Flex>
        </Box>

        <Box display={['none', 'none', 'block']}>
          <Grid
            templateColumns={[
              'repeat(1, 1fr)',
              'repeat(1, 1fr)',
              'repeat(5, 1fr)'
            ]} gap={[2, 6]}
          >
            <GridItem overflow='hidden'>
              <Text
                w='fit-content'
                fontSize={['xs', 'xs', 'xs', 'md']} color='gray.500'>
                #{order._id}
              </Text>
            </GridItem>

            <GridItem overflow='hidden'>
              <Text
                fontSize={['xs', 'xs', 'xs', 'md']} color={order.payment_method === 'cod' ? 'blue.500' : 'green.500'}>
                {order.payment_method === 'cod' ? 'C.O.D' : 'Card'}
              </Text>
            </GridItem>

            <GridItem overflow='hidden'>
              <Text
                fontSize={['xs', 'xs', 'xs', 'md']} color={order.payment_provider === 'cod' ? 'orange.500' : 'purple.500'}>
                {order.payment_provider === 'paystack' ? 'Paystack' : order.payment_provider === 'flutterwave' ? 'Flutterwave' : 'C.O.D'}
              </Text>
            </GridItem>

            <GridItem overflow='hidden'>
              <Text
                fontSize={['xs', 'xs', 'xs', 'md']} color='gray.500'>
                #{order.amount}
              </Text>
            </GridItem>

            <GridItem overflow='hidden'>
              <Text
                fontSize={['xs', 'xs', 'xs', 'md']} color='pink.500'>
                {order.date_placed}
              </Text>
            </GridItem>
          </Grid>
        </Box>
      </CustomButton>
    </Link>
  )
}

export default Order